require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/core-js/library/modules/web.dom.iterable.js
 ** module id = 1243
 ** module chunks = 0
 **/